document.addEventListener("DOMContentLoaded", () => {
  const faqs = document.querySelectorAll(".custom-faq-item");

  faqs.forEach((faq) => {
    const summary = faq.querySelector(".custom-faq-summary");
    const answer = faq.querySelector(".custom-faq-answer-container");

    // Initial state
    if (!faq.hasAttribute("open")) {
      answer.style.maxHeight = "0px";
      answer.style.opacity = "0";
    }

    summary.addEventListener("click", (e) => {
      e.preventDefault();

      const isOpen = faq.hasAttribute("open");

      // Close other accordions
      faqs.forEach((item) => {
        if (item !== faq) {
          item.removeAttribute("open");

          const otherAnswer = item.querySelector(
            ".custom-faq-answer-container"
          );

          otherAnswer.style.maxHeight = "0px";
          otherAnswer.style.opacity = "0";
        }
      });

      if (isOpen) {
        // CLOSE
        answer.style.maxHeight = answer.scrollHeight + "px";

        requestAnimationFrame(() => {
          answer.style.maxHeight = "0px";
          answer.style.opacity = "0";
        });

        setTimeout(() => {
          faq.removeAttribute("open");
        }, 400);

      } else {
        // OPEN
        faq.setAttribute("open", "");

        requestAnimationFrame(() => {
          answer.style.maxHeight = answer.scrollHeight + "px";
          answer.style.opacity = "1";
        });
      }
    });
  });
});